 <template>
  <section class="vx-card" role="region" :aria-label="title || 'Карточка'">
    <header v-if="title">
      <h4 class="vx-card__title">{{ title }}</h4>
    </header>
    <div class="vx-card__body" v-if="this.$slots.default">
        <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/vuesax/_variables';

  .vx-card{
    width: 100%;
    background: $white;
    border-radius: $size-2;
    padding: $size-3;
    display: block;
    position: relative;
    transition: all .3s ease-in-out;
    margin: 0 0 $size-3;
  }

  .vx-card__title {
    font-size: $h1-font-size;
    margin-bottom: $size-2;

    @media (max-width: 576px) {
      font-size: $h2-font-size;
    }
  }
</style>
